import {useSelector} from 'react-redux'

/**
 * Custom React Hook to get count value from state.
 * @see https://reactjs.org/docs/hooks-custom.html
 */


const useVideoAPI = () => useSelector(state => state.videoLink)

export default useVideoAPI